export function storedRefreshToExtraDayString(jwtDeviceExpiration, refreshDeviceExpiration) {
  if (jwtDeviceExpiration == null || refreshDeviceExpiration == null) return '';
  const jwt = Number(jwtDeviceExpiration);
  const total = Number(refreshDeviceExpiration);
  if (!Number.isFinite(jwt) || !Number.isFinite(total)) return '';
  return String(Math.max(0, total - jwt));
}
